import React, { useState } from "react";
import moment from "moment/moment";
import SearchInput from "./SearchInput";
import CustomSelect from "./CustomSelect";
import ArrowDownIcon from "../../assets/icons/arrowDown";
import PrevIcon from "../../assets/icons/prev";
import NextIcon from "../../assets/icons/next";
import { Link } from "react-router-dom";
import { IoMdEye } from "react-icons/io";
import { capitalCase } from "../../Utils/getUserUtitls";

const TeamMemberTable = ({ data, designationOptions }) => {
  const [search, setSearch] = useState("");
  const [designationFilter, setDesignationFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [pageInput, setPageInput] = useState("");

  // Filter logic
  const filteredData = data.filter((row) => {
    const name = [row?.first_name, row?.middle_name, row?.last_name]
      .filter(Boolean)
      .join(" ");
    const status = row.status === 1 ? "Active" : "Non Active";
    return (
      name?.toLowerCase().includes(search.toLowerCase()) &&
      (designationFilter ? row.designation_id === designationFilter : true) &&
      (statusFilter ? status === statusFilter : true)
    );
  });

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handlePageJump = (e) => {
    e.preventDefault();
    const pageNum = parseInt(pageInput, 10);
    if (!isNaN(pageNum)) {
      handlePageChange(pageNum);
      setPageInput("");
    }
  };

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Active",
      value: "Active",
    },
    {
      label: "Non Active",
      value: "Non Active",
    },
  ];

  function getDesignationLabelById(id) {
    console.log(designationOptions);
    const designation = designationOptions.find((item) => item.value === id);
    return designation ? designation.label : null; // returns null if not found
  }

  return (
    <div className="w-full rounded-lg">
      {/* Filters */}
      <div className="flex justify-between items-start md:flex-row gap-3 mb-4 z-20">
        <SearchInput
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by name..."
          fontSize="sm"
        />
        <div className="flex flex-grow-0 flex-shrink-0 gap-4">
          <CustomSelect
            options={designationOptions}
            placeholder="Designation"
            value={designationFilter}
            onChange={(des) => setDesignationFilter(des.value)}
            width="w-[200px]"
            height="h-[36px]"
            fontSize="sm"
            optionFontSize="sm"
          />

          <CustomSelect
            options={statusOptions}
            placeholder="Status"
            value={statusFilter}
            onChange={(des) => setStatusFilter(des.value)}
            width="w-[120px]"
            height="h-[36px]"
            fontSize="sm"
            optionFontSize="sm"
          />
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto z-0">
        <table className="min-w-[800px] table-auto w-full text-sm">
          <thead className="sticky top-0 bg-white z-0">
            <tr className="h-[52px] border border-l-0 border-r-0 border-[#a48572]/10 text-[#142b70]">
              <th className="px-4 text-left font-semibold whitespace-nowrap">
                Employee Name
              </th>
              <th className="px-4 text-left font-semibold whitespace-nowrap">
                Designation
              </th>
              <th className="px-4 text-center font-semibold whitespace-nowrap">
                Joining Date
              </th>
              <th className="px-4 text-center font-semibold whitespace-nowrap">
                Phone Number
              </th>
              <th className="px-4 text-center font-semibold whitespace-nowrap">
                Location
              </th>
              <th className="px-4 text-center font-semibold whitespace-nowrap">
                Status
              </th>
              <th className="px-4 text-center font-semibold whitespace-nowrap">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {currentRows.length > 0 ? (
              currentRows.map((row, idx) => (
                <tr key={idx} className="relative hover:bg-[#f9f9f9]">
                  <td className="relative text-left py-3 pl-3 min-w-48">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 overflow-hidden rounded-lg bg-[#de2b26] flex items-center justify-center">
                        <span className="text-sm text-white">
                          {row.employee_name
                            ? row.employee_name.charAt(0)
                            : "N"}
                        </span>
                      </div>
                      <p className="text-sm text-[#142b70]/80">
                        {row.first_name
                          ? [row?.first_name, row?.middle_name, row?.last_name]
                              .filter(Boolean)
                              .join(" ")
                          : "N/A"}
                      </p>
                    </div>
                  </td>

                  <td className="text-sm text-[#142b70]/80 text-left px-4 py-3">
                    {row.designation_id
                      ? getDesignationLabelById(row?.designation_id)
                      : "N/A"}
                  </td>
                  <td className="text-sm text-[#142b70]/80 text-center py-3">
                    {row.joining_date
                      ? moment(row.joining_date).format("DD MMM YYYY")
                      : "N/A"}
                  </td>
                  <td className="text-sm text-[#142b70]/80 text-center py-3">
                    {row.phone ? row.phone : "N/A"}
                  </td>
                  <td className="text-sm text-[#142b70]/80 text-center py-3">
                    {row.location_id
                      ? row.location_id === 1
                        ? "Dubai"
                        : row.location_id === 2
                        ? "India"
                        : ""
                      : "N/A"}
                  </td>
                  <td className="text-center py-3">
                    <div
                      className={`flex justify-center mx-auto items-center w-[90px] px-2 py-1 rounded ${
                        row.current_day_attendance?.status === "present"
                          ? "bg-[#32936f]/[0.16]"
                          : "bg-[#de2b26]/10"
                      }`}
                    >
                      <p
                        className={`text-xs ${
                          row.current_day_attendance?.status === "present"
                            ? "text-[#519c66]"
                            : "text-[#142b70]"
                        }`}
                      >
                        {capitalCase(row.current_day_attendance?.status)}
                      </p>
                    </div>
                  </td>
                  <td className="text-right py-3 px-3">
                    <div className="flex justify-center gap-2">
                      <Link
                        to={`/view-employee/${row.id}`}
                        className={`flex justify-center items-center mx-auto px-2 py-1 rounded bg-[#de2b26]/10 cursor-pointer`}
                      >
                        <IoMdEye className={`text-xs text-[#142b70]`} />
                      </Link>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4">
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-4">
        <div className="relative w-[190px] h-[30px] flex items-center justify-between">
          {/* Page Selector */}
          <div className="flex items-center gap-2">
            <div className="flex items-center h-[26px] px-[10px] rounded-lg bg-[#f9f9f9] cursor-pointer relative">
              <select
                value={currentPage}
                onChange={(e) => handlePageChange(Number(e.target.value))}
                className="bg-transparent text-xs text-[#142b70]/80 focus:outline-none cursor-pointer appearance-none pr-5"
              >
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </select>
              {/* Down Arrow */}
              <ArrowDownIcon
                iconClass="absolute right-2 pointer-events-none"
                color="#142b70"
              />
            </div>
            <p className="text-sm text-[#142b70]/80">of {totalPages} pages</p>
          </div>

          {/* Prev / Next Arrows */}
          <div className="flex items-center gap-3">
            {/* Prev */}
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="disabled:opacity-40"
            >
              <PrevIcon color="#142b70" />
            </button>

            {/* Next */}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="disabled:opacity-40"
            >
              <NextIcon color="#142b70" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMemberTable;
